import useUserPreferences from '@frolight/hooks/useUserPreferences';
import MathUtils from '@frolight/utils/MathUtils';
import UnitConversionUtils from '@frolight/utils/UnitConversionUtils';

const useRenderValuesInPreferredUnit = () => {

  const { userPreferences } = useUserPreferences();

  const renderTemperature = (temperatureInCelsius, precision = 4) => {
    switch (userPreferences.temperatureUnit) {
      case 'celsius':
        return `${temperatureInCelsius} °C`;
      case 'fahrenheit':
        const convertedValue = MathUtils.precisionRound(
          UnitConversionUtils.convertTemperature(temperatureInCelsius, 'celsius', 'fahrenheit'),
          precision
        );
        return `${ convertedValue } °F`;
    }
  }

  return { renderTemperature };

};

export default useRenderValuesInPreferredUnit;